var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67446 13.8427L6.42578 14.913V10.5742H9.57393V14.913L8.32525 13.8427L7.99986 13.5638L7.67446 13.8427Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15482 2.12021L9.29687 2.23027L9.47648 2.22472L10.937 2.17965L11.3454 3.5826L11.3957 3.75513L11.5442 3.85621L12.7523 4.67821L12.2581 6.0533L12.1973 6.2224L12.2581 6.39151L12.7523 7.7666L11.5442 8.58859L11.3957 8.68968L11.3454 8.86221L10.937 10.2652L9.47648 10.2201L9.29687 10.2145L9.15482 10.3246L7.99975 11.2195L6.84467 10.3246L6.70262 10.2145L6.52302 10.2201L5.06251 10.2652L4.65406 8.86221L4.60383 8.68968L4.45527 8.58859L3.2472 7.7666L3.74139 6.39151L3.80217 6.2224L3.74139 6.0533L3.2472 4.67821L4.45527 3.85621L4.60383 3.75513L4.65406 3.5826L5.06251 2.17965L6.52302 2.22472L6.70262 2.23027L6.84467 2.12021L7.99975 1.22528L9.15482 2.12021Z",
    fill: "#5283EC",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 1.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.6b570d52d506f26df1bf193834a435d0.svg";
export { ForwardRef as ReactComponent };